
import React from 'react';
import { Shield, Map, LayoutGrid, Zap, Rocket, Users, Globe, TrendingUp } from 'lucide-react';

export const PROBLEMS = [
  { title: "Lost Visitors", description: "Broken wayfinding leads to confusion and poor first impressions.", icon: <Map className="w-6 h-6 text-rose-400" /> },
  { title: "Staff Overload", description: "Security and reception staff buried in repetitive, low-value manual tasks.", icon: <Users className="w-6 h-6 text-rose-400" /> },
  { title: "No Intelligence", description: "Complete lack of data on pedestrian movement, usage patterns, or congestion.", icon: <LayoutGrid className="w-6 h-6 text-rose-400" /> },
  { title: "Import Trap", description: "Expensive hotel robots are completely unfit for rugged Indian campus environments.", icon: <Zap className="w-6 h-6 text-rose-400" /> }
];

export const SOLUTIONS = [
  { title: "Digital Escort", description: "Fully autonomous indoor navigation with natural voice guidance.", icon: "🗺️" },
  { title: "ERP Sync", description: "Seamless integration with calendar, hostel, and visitor management logs.", icon: "🔗" },
  { title: "Security AI", description: "Real-time heatmaps, safety alerts, and incident audit trails.", icon: "🛡️" },
  { title: "Subscription", description: "Robotics-as-a-Service model: zero CAPEX, predictable monthly costs.", icon: "💰" }
];

export const MARKET_STATS = [
  { value: "1.5T+", label: "Global TAM", icon: <Globe className="w-8 h-8" /> },
  { value: "25K+", label: "Target Colleges", icon: <LayoutGrid className="w-8 h-8" /> },
  { value: "20%", label: "Category CAGR", icon: <TrendingUp className="w-8 h-8" /> },
  { value: "50+", label: "Planned Deploys", icon: <Rocket className="w-8 h-8" /> }
];

export const ROADMAP = [
  { id: "01", title: "Prototype", description: "MVP campus deployment with live real-world validation." },
  { id: "02", title: "Scale", description: "Deploying to 20+ colleges across Tier-2 and Tier-3 cities." },
  { id: "03", title: "Expansion", description: "Branching into hospitals, malls, and hospitality sectors." }
];

export const SUPABASE_CONFIG = {
  url: "https://lmfuxxdmdnmwzvjwxrab.supabase.co",
  key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxtZnV4eGRtZG5td3p2and4cmFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU2MTMzNDYsImV4cCI6MjA4MTE4OTM0Nn0.MjcOLcXyoVCWMUlj6n3hxxHFdk1NkAZ6D8TQLwoEwm8"
};
